import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AppRouting } from '../../app-routing.module';
import { ApiPublicService } from '../../../lib/lib-ngx/web-services/api-public.service';
import { PickupService } from '../../services/pickup.service';
import { ConfirmationModalComponent } from '../../modals/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  public loginForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private apiPublicService: ApiPublicService,
    private pickupService: PickupService,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit() {
    this.pickupService.setPickupMode(this.route.snapshot.queryParamMap.get('pickup') === 'true');
    this.buildForm();
  }

  buildForm() {
    this.loginForm = this.fb.group({
      pickupId: ['', Validators.required]
    });
  }

  onLogin() {
    this.apiPublicService.getPickupPickupId(this.loginForm.value.pickupId, {})
      .subscribe(data => {
        if (data) {
          this.pickupService.setPickup(data);
          this.router.navigate([AppRouting.ORDER_LIST]);
        } else {
          const confirmationModal = this.modalService.open(ConfirmationModalComponent, {
            size: 'xl' as 'lg',
            backdrop: 'static',
            keyboard: false,
            centered: true
          });
          confirmationModal.componentInstance.confirmationDesc = 'Identifiant inconnu';
          confirmationModal.componentInstance.validateButtonText = 'Ok';
        }
      });
  }
}
